// extracted by mini-css-extract-plugin
export default {"textcontent":"Home_textcontent__1sI1f"};